import React, { useState, useRef, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import 'react-quill/dist/quill.snow.css';
import { useReactToPrint } from 'react-to-print';
import "./SpeakingAgreement.scss"
import { Editor } from '@tinymce/tinymce-react';
import { ProposalViewApi } from '../../Constants/Api/Api';
import { useParams } from 'react-router-dom';
import Signin from '../../Pages/Signin/Signin';
const SpeakingAgreement = () => {
    const { id } = useParams()
    const [companyLogo, setcompanyLogo] = useState('');
    const [initialContent, setInitialContent] = useState(`<p>This agreement is between XYZ Inc., (Consultant) and ______________________ (Company), __________________________(Address).</p><p>_______________________(Company) wishes to retain the services of John Doe&nbsp;to deliver a</p><p>presentation for&nbsp;_______________________(Event) as follows:</p><p><strong>Date:&nbsp;_______________________&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong></p><p><strong>Program Time:&nbsp;_______________________</strong></p><p><strong>Program Location: _______________________</strong></p><p><strong>Program Title: _______________________</strong></p><p><strong>Number of Participants:</strong> ___________________</p><p>XYZ Inc. and John Doe agree to present to the best of our ability the information and material contained in the program described above.&nbsp;We also agree to coordinate the details of this program with the Client in order to achieve the outcomes that the Client has stated.&nbsp;The Client agrees to duplicate the learning materials provided by the consultant, and to provide the room setup and audiovisual equipment described in the enclosed program logistics sheet.</p><p>In exchange for the products and services provided, the Client agrees to compensate XYZ Inc. as follows:</p><p><strong>Professional Fee:</strong> $XXXX</p><p><strong>Travel:</strong> All reasonable and customary travel expenses including coach airfare, ground , lodging, meals, and related out of pocket expenses.&nbsp;A complete travel expense report will be submitted with our invoice.</p><p><strong>Deposit: </strong>In order to confirm this agreement, client agrees to pay a deposit of 15% of the professional fee at the time this agreement is signed.</p><p><strong>Balance:</strong> Client agrees to pay the balance of $XXXX on the date of the meeting. Client agrees to pay all travel expenses and materials fees within ten business days of receipt of our invoice.&nbsp;</p><p>In the event the client makes any change in the program date as shown above, the deposit sum of&nbsp;$XXX will be retained by XYZ Inc. and applied to any future presentations or consulting assignment for a period of one year from the date the consultant was notified of the change.&nbsp;In addition, if the change is made within 30 days of the program date, client shall be responsible for reimbursing all costs incurred by the consultant related to the presentation.&nbsp;</p><p>The client agrees not to audio or video tape the presentation without prior written agreement.&nbsp;</p><p>This constitutes the entire agreement between the parties.</p><p><br></p><p><span >By</span>:<span >_________</span></p><p><span >Co</span>:<span >_________</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p><p><span >Title</span>:<span >_________</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p><p><span >Date</span>:<span >_________</span></p><p class="ql-align-right"><span >By</span>:<span >_________</span></p><p class="ql-align-right"><span >Co</span>:<span >_________</span></p><p class="ql-align-right"><span >Title</span>:<span >_________</span></p><p class="ql-align-right"><span >Date</span>:<span >_________</span></p>`);
    const [content, setContent] = useState(initialContent);
    const [lgShow, setLgShow] = useState(false);
    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const contentRef = useRef();
    // const [loading, setLoading] = useState(false);
    const handleClose = () => {
        if (unsavedChanges && window.confirm('You have unsaved changes. Do you want to discard them?')) {
            handleCloseModal();
            return;
        }
        // If there are unsaved changes and user wants to keep them, prevent closing the modal
        if (unsavedChanges) {
            return;
        }
        handleCloseModal(); // No unsaved changes, close the modal
    };
    const handleCloseModal = () => {
        setLgShow(false);
        setContent(initialContent);
        setUnsavedChanges(false);
    };
    const handleSave = () => {
        setInitialContent(content);
        setUnsavedChanges(false);
        setLgShow(false); // Close the modal after saving changes
    };
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [])
    const handleImageChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            const imageUrl = URL.createObjectURL(selectedFile);
            setcompanyLogo(imageUrl);
        }
    };
    const handlePrint = useReactToPrint({
        content: () => contentRef.current,
        pageStyle: `
        @page {
          margin: 24.5mm;
        }`
    });
    useEffect(()=>{

        // ProposalViewApi(id).then((res) => {
        // }).catch((e) => {
        // })
    },[id])
    const isToken = localStorage.getItem("UserLoginTokenApt")

    return (<>
        {!isToken && isToken == null ? <Signin
            /> :
        <div className='spc'>
            <div className='editbutton'>
                <div className='editbutton'>
                    <Button onClick={() => setLgShow(true)} className="button_theme">Edit template</Button>
                    <button className="button_theme" onClick={handlePrint}>Generate PDF</button>
                </div>
            </div>
            <Modal
                size="lg"
                show={lgShow}
                onHide={handleClose}
                aria-labelledby="example-modal-sizes-title-lg"
                centered
            >
                <Modal.Body>
                    {/* {loading ? (
                        <div className="text-center">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    ) : ( */}
                        <Editor
                            apiKey='f8i59q6p88hcyvaqhicwhyjs2cqwzr8elruwyxphppvzc5yd'
                            value={content}
                            init={{
                                plugins: 'table  ',
                                // plugins: 'ai tinycomments mentions anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed permanentpen footnotes advtemplate advtable advcode editimage   mergetags powerpaste tinymcespellchecker autocorrect a11ychecker typography inlinecss',
                                toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | align lineheight | tinycomments | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                                tinycomments_mode: 'embedded',
                                tinycomments_author: 'Author name',
                                mergetags_list: [
                                    { value: 'First.Name', title: 'First Name' },
                                    { value: 'Email', title: 'Email' },
                                ],
                                ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
                            }}
                            onClick={() => setUnsavedChanges(true)}
                            onEditorChange={(newContent, editor) => {
                                setContent(newContent);
                            }}
                        />
                    {/* )} */}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
            <div ref={contentRef}>
                <div className='Proposal1 SepakingAggrement'>
                    <div style={{ textAlign: "center" }}>
                        {companyLogo ? (
                            <img
                                src={companyLogo}
                                height="100px"
                                width="100px"
                                alt="Profile Pic"
                                style={{ borderRadius: "50%" }}
                            />
                        ) : (
                            <label className="custom-file-upload">
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                />
                                Add Company Logo
                            </label>
                        )}
                    </div>
                    <h3 style={{ fontSize: '20px' }}>Speaking Agreement</h3>
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                </div>
            </div>
        </div>
                        }
                        </>
    );
};
export default SpeakingAgreement;
